function contextFromRoles(roles = []) {
  if (roles.includes('PARTNER_ASSOCIATE')) return 'Administración partner';
  if (roles.includes('USER')) return 'App';
  if (roles.includes('PARTNER')) return 'Partner';
  return null;
}

function formatAccountLabel({ username, email, context, partners = [] }) {
  const name = username || email;
  const partnerNames = partners.map((partner) => partner.username).filter(Boolean);
  if (!partnerNames.length) return `${name} — ${context}`;
  return `${name} — ${context} · ${partnerNames.join(', ')}`;
}

module.exports = {
  contextFromRoles,
  formatAccountLabel,
};
